export type DeviationState = 'none' | 'below' | 'above'

const CENT_TOLERANCE = 0.005

export const getDeviationState = (
  budgetAmount?: number | null,
  previewAmount?: number | null
): DeviationState => {
  if (previewAmount == null) return 'none'

  const deviation = previewAmount - (budgetAmount ?? 0)

  if (Math.abs(deviation) < CENT_TOLERANCE) return 'none'

  return deviation > 0 ? 'below' : 'above'
}
